import React, { useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box } from "@chakra-ui/react";
import OrdersTab from "../../components/orders/OrdersTab";

export default function Orders() {
  useEffect(() => {
    document.title = "Orders";
  }, []);

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box mt='20px'>
          <OrdersTab />
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}